import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import applicationJson from '../../../.application.json';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export type ISettingsParams = {
  greetingsText: SettingsParamType.Text;
};

export default createSettingsParams<ISettingsParams>({
  greetingsText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) =>
      `${t('app.settings.defaults.greetingsPretext')} ${
        applicationJson.appName
      }`,
    metadata: {
      type: DataType.direction,
      defaultValue: {
        type: 'static',
        value: 'STATIC',
      },
    },
  },
});
